import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserProfile, UserSessionDetail } from '../../interface/user.interface';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private _userDetail: UserSessionDetail | null = null;

  constructor(
    private readonly _httpService: HttpService
  ) {}

  setUserDetail(userDetail: Partial<UserSessionDetail>): void {
    const existingDetail: UserSessionDetail = this._userDetail || ({} as UserSessionDetail);
    const incomingDetail: Partial<UserSessionDetail> = userDetail || {};

    const mergedUser = {
      ...(existingDetail.user || {}),
      ...(incomingDetail.user || {}),
    };

    const mergedDetail = {
      ...existingDetail,
      ...incomingDetail,
      ...(Object.keys(mergedUser).length ? { user: mergedUser } : {}),
    } as UserSessionDetail;

    this._userDetail = mergedDetail;
    sessionStorage.setItem('userInfo', JSON.stringify(mergedDetail));
  }

  getUserDetail(): UserSessionDetail | null {
    if (!this._userDetail) {
      const stored = sessionStorage.getItem('userInfo');
      this._userDetail = stored ? (JSON.parse(stored) as UserSessionDetail) : null;
    }
    return this._userDetail;
  }

  isAuthenticated(): boolean {
    const userSessionInfo = this.getUserDetail();
    return !!userSessionInfo?.access_token;
  }

  get getAuthToken(): string {
    const userSessionInfo = this.getUserDetail();
    return userSessionInfo?.access_token ? `Bearer ${userSessionInfo.access_token}` : '';
  }

  get getApiKey(): string {
    return environment.apiKey;
  }

  fetchUserProfile(): Observable<UserSessionDetail | null> {
    const userSessionInfo = this.getUserDetail();
    if (!userSessionInfo?.access_token) {
      return of(null);
    }

  const fetchPromise = fetch(`${environment.apiUrl}/auth/v1/user`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${userSessionInfo.access_token}`,
        apikey: this.getApiKey,
        'Content-Type': 'application/json',
      },
    }).then(response => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return response.json();
    });

  return new Observable<UserSessionDetail | null>(observer => {
      fetchPromise
        .then(user => {
          const enrichedUserData: UserSessionDetail = {
            ...userSessionInfo,
            user,
          };
          this.setUserDetail(enrichedUserData);
          observer.next(enrichedUserData);
          observer.complete();
        })
        .catch(error => {
          console.error('Failed to fetch user profile:', error);
          observer.next(null);
          observer.complete();
        });
    });
  }
}
